import Vue from 'vue';
import VTooltip from 'v-tooltip'


import { ValidationMessages } from "@/services/validator/localization";
import { Validator } from "vee-validate";
import VeeValidate from "vee-validate";

import $ from 'jquery';

import projectPage from "@/components/project-page/project-page.vue";
import categoryPage from "@/components/category-page/category-page.vue";

Vue.config.productionTip = false;

Validator.localize({ en: ValidationMessages.en });
Vue.use(VeeValidate, { locale: "en" });
// Vue.use($);
Vue.use(VTooltip);


// Vue.component('projectPage', require('./components/project-page/project-page').default);
Vue.component('categoryPage', require('./components/category-page/category-page.vue').default);

declare let isCategoryPage;
export const getIsCategoryPage = () => {
    if (typeof isCategoryPage != "undefined")
        return isCategoryPage;
    return true;
};
if(getIsCategoryPage()){
    new Vue({
        render(h) {
            return h(categoryPage, { props: {} });
        },
        methods: {}
    }).$mount('#lc-app');
}else{
    new Vue({
        render(h) {
            return h(projectPage, { props: {} });
        },
        methods: {}
    }).$mount('#lc-app-project');
}





